interface ExerciseCategoryItemProps {
  label: string;
  attributes: string;
}

export function ExerciseCategoryItem(props: ExerciseCategoryItemProps) {
  return (
    <div className="flex flex-col">
      <span>{props.label}</span>
      <span className="text-xs text-muted-foreground">{props.attributes}</span>
    </div>
  );
}
